import React, { FC } from "react";
import {
  Typography,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import { green } from "@mui/material/colors";
import { Done as DoneIcon } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import useFreightMarkupSelector from "./useFreightMarkupSelector";

const StyledColDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  padding: 20,
  margin: 20,
});

const StyledCircularProgress = styled(CircularProgress)({
  color: green[500],
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: "-12px",
  marginLeft: "-12px",
});

interface DeliveryMarkupProps {
  crateFreightMarkup: string;
  changeCrateFreightMarkup: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CrateFreightMarkup: FC<DeliveryMarkupProps> = ({
  crateFreightMarkup,
  changeCrateFreightMarkup,
}) => {
  const { handleButtonClick, buttonSx, loading, success } =
    useFreightMarkupSelector(crateFreightMarkup);

  return (
    <StyledColDiv style={{ height: 350, justifyContent: "center" }}>
      <StyledColDiv style={{padding:0, margin:0}}>
     <Typography>
        Do you want to add mark-up/margin to crate and freight charge?
      </Typography>
      <Typography variant="subtitle2">*only applies to delivery addresses outside of California</Typography>
      </StyledColDiv>

      <FormControl style={{ marginTop: 10 }}>
        <RadioGroup value={crateFreightMarkup} onChange={changeCrateFreightMarkup}>
          <FormControlLabel value="No" control={<Radio />} label="No" />
          <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
        </RadioGroup>
      </FormControl>

      <Box sx={{ m: 1, position: "relative", marginTop: 5 }}>
        <Button
          variant="contained"
          sx={buttonSx}
          disabled={loading}
          onClick={handleButtonClick}
          startIcon={success && <DoneIcon />}
        >
          Apply
        </Button>
        {loading && <StyledCircularProgress size={24} />}
      </Box>
    </StyledColDiv>
  );
};

export default CrateFreightMarkup;
